import {
  CognitoIdentityProviderClient,
  GetUserCommand,
} from "@aws-sdk/client-cognito-identity-provider";

/**
 * Fetch user attributes (including custom ones) from Cognito using access token
 * @param {string} accessToken - the access token from the authenticated user
 * @returns {Promise<Object>} - object with attributes
 */
export async function fetchUserAttributes(accessToken) {
  // 👇 use the region where your user pool is located (e.g., "us-east-2", "us-west-1")
  const client = new CognitoIdentityProviderClient({ region: "us-east-2" });

  const command = new GetUserCommand({ AccessToken: accessToken });
  const response = await client.send(command);

  // Convert the array to a simpler object
  const attributes = {};
  response.UserAttributes.forEach((attr) => {
    attributes[attr.Name] = attr.Value;
  });

  return attributes;
}